namespace $ {

	export class $shm_wordstat_perf extends $mol_object2 {

		@ $mol_mem_key
		static started_at( task: string, next?: number ) {
			return next ?? 0
		}

		static start( task: string, kind = 'open' ) {
			this.started_at( `${ task }:${ kind }`, $mol_dom_context.performance.now() )
		}

		static start_mode( task: string, mode: string ) {
			this.start( task, `mode_switch:${ mode }` )
		}

		static finish( task: string, mode: string ) {
			this.finish_kind( task, mode, 'open' )
			this.finish_kind( task, mode, `mode_switch:${ mode }` )
		}

		static finish_kind( task: string, mode: string, kind: string ) {
			const key = `${ task }:${ kind }`
			const started = this.started_at( key )
			if( !started ) return

			this.started_at( key, 0 )
			const duration = $mol_dom_context.performance.now() - started
			const operation = kind.startsWith( 'mode_switch:' ) ? ` mode_switch=${ mode }` : ` mode=${ mode }`
			console.info( `[wordstat-client] task=${ task }${ operation } loaded_ms=${ duration.toFixed( 1 ) }` )
		}

	}

	export class $shm_wordstat_perf_ready extends $mol_view {

		task_id() {
			return ''
		}

		mode() {
			return ''
		}

		ready() {
			return false
		}

		override dom_tree() {
			const node = super.dom_tree()
			if( this.ready() ) $shm_wordstat_perf.finish( this.task_id(), this.mode() )
			return node
		}

	}

}
